import React from 'react';
import { Grid, Segment } from 'semantic-ui-react';

export default function LoadingComponent({
  loading
}) {
  return (
    <Grid>
      <Grid.Row>
        <Grid.Column>
          <Segment style={{ height: '90vh' }} loading={loading} />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}



// WEBPACK FOOTER //
// ./src/Modules/Loading/component.jsx